import { graphql } from "@opensea/graphql"

export const useCollectionTabsFragment = graphql(`
  fragment useCollectionTabs on Collection {
    slug
    flags {
      isOffersEnabled
    }
    overview {
      modules {
        __typename
      }
    }
    drop {
      type
    }
    currencies {
      __typename
    }
    previewItems(limit: 1) {
      isFungible
      rarity {
        rank
      }
    }
    stats {
      uniqueItemCount
    }
    flags {
      supportsAttributesBySlug
    }
  }
`)
